import { createI18n } from 'vue-i18n';

function loadLocaleMessages() {
  try {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages = {};
    locales.keys().forEach((key) => {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i);
      if (matched && matched.length > 1) {
        const locale = matched[1];
        const localeData = locales(key);
        messages[locale] = localeData.default || localeData;
      }
    });
    return messages;
  } catch (e) {
    // jest doesn't support require.context; return empty for test environment
    return {};
  }
}

function customRule(choice /*, choicesLength  , orgRule */) {
  if (choice === 0) {
    return 0;
  }
  if (choice === 1) {
    return 1;
  }
  return choice < 5 ? 2 : 3;
}
const datetimeFormats = {
  uk: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
  ru: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
  es: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
  pt: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    },
  },
};
const numberFormats = {
  uk: {
    currency: {
      style: 'currency',
      currency: 'UAH',
      useGrouping: true,
      currencyDisplay: 'symbol',
    },
    decimal: {
      style: 'decimal',
      minimumSignificantDigits: 3,
      maximumSignificantDigits: 5,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  en: {
    currency: {
      style: 'currency',
      currency: 'USD',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  ru: {
    currency: {
      style: 'currency',
      currency: 'RUB',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  es: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
  pt: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
    },
    decimal: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
  },
};
const messages = loadLocaleMessages();
// console.log('Loaded i18n messages:', messages);

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'ru',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
  messages,
  datetimeFormats,
  numberFormats,
  pluralizationRules: {
    uk: customRule,
    ru: customRule,
  },
  missingWarn: false,
  fallbackWarn: false,
});
